import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { UserCircle, AlertTriangle, MessageCircleQuestion } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface ProfileIncompleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  missingQuestions?: boolean;
}

export function ProfileIncompleteDialog({ 
  open, 
  onOpenChange,
  missingQuestions = false 
}: ProfileIncompleteDialogProps) {
  const navigate = useNavigate();

  const handleGoToProfile = () => {
    onOpenChange(false);
    navigate("/profile");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center">
          <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-amber-500/20 flex items-center justify-center">
            {missingQuestions ? (
              <MessageCircleQuestion className="w-8 h-8 text-amber-500" />
            ) : (
              <AlertTriangle className="w-8 h-8 text-amber-500" />
            )}
          </div>
          <DialogTitle className="text-xl font-display tracking-wide">
            COMPLETE SEU PERFIL
          </DialogTitle>
          <DialogDescription className="text-center pt-2">
            Para iniciar o cadastro como modelo, você precisa primeiro preencher todas as informações do seu perfil.
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-4 space-y-3">
          <p className="text-sm text-muted-foreground text-center">
            Preencha seus dados pessoais e foto de perfil.
          </p>
          <div className="p-3 bg-primary/10 rounded-lg border border-primary/20">
            <p className="text-sm text-center font-medium flex items-center justify-center gap-2">
              <MessageCircleQuestion className="w-4 h-4 text-primary" />
              Responda as 5 perguntas do perfil
            </p>
            <p className="text-xs text-muted-foreground text-center mt-1">
              As perguntas são obrigatórias para iniciar o cadastro
            </p>
          </div>
        </div>

        <DialogFooter className="sm:justify-center">
          <Button onClick={handleGoToProfile} className="w-full sm:w-auto gap-2">
            <UserCircle className="w-4 h-4" />
            Ir para Preencher o Perfil
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
